import { GridAreas } from './types';

export const gridAreas: GridAreas = {
	bigImageFirst: {
		areas: `'big small1'
				'big small2'`,
		areasMobile: `'big big'
				'small1 small2'`,
		gridTemplateColumns: '72fr 27fr',
		gridTemplateColumnsMobile: '1fr 1fr',
		gridTemplateRows: '1fr 1fr',
		itemAreas: {
			0: 'big',
			1: 'small1',
			2: 'small2',
		},
		aspectRatios: {
			0: '4/3',
			1: '1/1',
			2: '1/1',
		},
	},
	smallImagesFirst: {
		areas: `'small1 big'
		'small2 big'`,
		areasMobile: `'big big'
		'small1 small2'`,
		gridTemplateColumns: '27fr 72fr',
		gridTemplateColumnsMobile: '1fr 1fr',
		gridTemplateRows: '1fr 1fr',
		itemAreas: { 0: 'small1', 1: 'small2', 2: 'big' },
		aspectRatios: {
			0: '1/1',
			1: '1/1',
			2: '4/3',
		},
	},
	twoThirdsOneThird: {
		areas: `'big small1'`,
		areasMobile: `'big small1'`,
		gridTemplateColumns: '72fr 27fr',
		gridTemplateColumnsMobile: '72fr 27fr',
		gridTemplateRows: '1fr',
		itemAreas: {
			0: 'big',
			1: 'small1',
		},
		aspectRatios: {
			0: '4/3',
			1: '1/2',
		},
	},
};
